import script from "./BillingCreateJa.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingCreateJa.vue?vue&type=script&setup=true&lang=js"

import "./BillingCreateJa.vue?vue&type=style&index=0&id=787bd590&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-787bd590"]])

export default __exports__